import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { RubWithdrawalRequestsContent } from "interfaces";

export class RubWithdrawalRequestsList extends ListStoreConstructor<RubWithdrawalRequestsContent> {
  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getWithdrawalRequests(params).then((response: any) => {
          return { ...response, content: response.content || [] };
        });
      },
      {
        pollingInterval: 30000,
        defaultSorters: { statusDate: "desc" },
      }
    );
  }
}
